<template>
    <div
        ref="root"
        :style="{ minHeight }">
        <slot v-if="isVisible" />
        <slot
            v-else
            name="fallback" />
    </div>
</template>

<script setup lang="ts">
const props = withDefaults(
    defineProps<{
        rootMargin?: string
        minHeight?: string
    }>(),
    {
        rootMargin: '600px',
        minHeight: '1px',
    }
)

const emit = defineEmits<{
    visible: []
}>()

const root = ref<HTMLElement | null>(null)
const isVisible = ref(false)
let observer: IntersectionObserver | null = null

function markVisible() {
    if (isVisible.value) return

    isVisible.value = true
    emit('visible')
    observer?.disconnect()
}

onMounted(() => {
    if (!root.value || !('IntersectionObserver' in window)) {
        markVisible()
        return
    }

    observer = new IntersectionObserver(
        ([entry]) => {
            if (entry?.isIntersecting) {
                markVisible()
            }
        },
        { rootMargin: props.rootMargin }
    )

    observer.observe(root.value)
})

onBeforeUnmount(() => {
    observer?.disconnect()
})
</script>
